var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToncoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3406_2283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#0088CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21395 6.60693H12.8211C13.0354 6.60693 13.2139 6.64265 13.4282 6.74979C13.6782 6.85693 13.8211 7.03551 13.8925 7.17836C13.8925 7.17836 13.8925 7.21408 13.9282 7.21408C14.0354 7.39265 14.1068 7.60693 14.1068 7.85693C14.1068 8.07122 14.0711 8.2855 13.9282 8.49979L10.3925 14.5712C10.3211 14.7141 10.1782 14.7855 9.99966 14.7855C9.85681 14.7855 9.71395 14.7141 9.60681 14.5712L6.14252 8.49979C6.07109 8.35693 5.92824 8.17836 5.92824 7.89265C5.89252 7.64265 5.96395 7.42836 6.07109 7.21408C6.17824 6.99979 6.35681 6.82122 6.60681 6.74979C6.82109 6.60693 7.07109 6.60693 7.21395 6.60693ZM9.57109 7.46408H7.21395C7.07109 7.46408 6.99966 7.46408 6.96395 7.49979C6.89252 7.5355 6.85681 7.57122 6.82109 7.64265C6.78538 7.67836 6.78538 7.74979 6.78538 7.82122C6.78538 7.85693 6.82109 7.89265 6.89252 8.0355L9.57109 12.6784V7.46408ZM10.4282 7.46408V12.7141L13.1425 8.0355C13.1782 7.96408 13.1782 7.89265 13.1782 7.82122C13.1782 7.74979 13.1782 7.67836 13.1425 7.64265C13.1068 7.60693 13.1068 7.57122 13.0711 7.57122L13.0354 7.53551C12.9639 7.49979 12.8925 7.49979 12.7854 7.49979H10.4282V7.46408Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3406_2283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToncoin);
export default __webpack_public_path__ + "static/media/toncoin.7dda1002c731586f387d2f2a3f643ec5.svg";
export { ForwardRef as ReactComponent };